@if (isMobileViewport && isMobileOpen) {
  <div
    class="fixed inset-0 z-30 bg-neutral-900/60 backdrop-blur-[1px] md:hidden transition-opacity duration-300"
    (click)="closeMobileMenu()"
  ></div>
}

<aside
  id="sidebarNav"
  [class.minimized]="isMinimized"
  class="sidebar-shell fixed left-0 top-0 z-40 flex h-full flex-col border-r border-neutral-200 text-neutral-700 shadow-sm transition-transform duration-300 dark:border-gray-800 dark:text-neutral-200"
  [style.width]="isMobileViewport ? '240px' : (isMinimized ? '60px' : '240px')"
  [style.transform]="isMobileViewport && !isMobileOpen ? 'translateX(-100%)' : 'translateX(0)'"
>
  <div
    class="sidebar-top-block relative border-b border-neutral-200 dark:border-gray-800"
    [class.p-6]="!isMinimized"
    [class.p-2]="isMinimized"
  >
    <div class="flex items-center gap-3" [class.justify-center]="isMinimized">
      <img
        src="assets/favicon/android-chrome-192x192.png"
        alt="OrgLines Logo"
        [class.w-11]="!isMinimized"
        [class.h-11]="!isMinimized"
        [class.w-10]="isMinimized"
        [class.h-10]="isMinimized"
        class="logo-mark object-contain flex-shrink-0"
      />
      @if (!isMinimized) {
        <div class="space-y-0.5">
          <h1 class="brand-title text-lg font-bold leading-tight tracking-tight text-neutral-900 dark:text-neutral-50 font-display">OrgLines</h1>
          <p class="brand-subtitle pt-0.5 text-xs font-medium leading-snug text-neutral-500 dark:text-neutral-400">
            {{ "ORGLINES_SUBTITLE" | translate }}
          </p>
        </div>
      }
    </div>
  </div>

  <app-navbar-body
    class="flex-1 min-h-0"
    [isMinimized]="isMinimized"
    (menuItemSelected)="onNavItemSelected()"
  />

  <div class="sidebar-bottom-block mt-auto hidden border-t border-neutral-200 p-3 dark:border-gray-800 md:block">
    <button
      type="button"
      (click)="toggleMenu()"
      class="collapse-button nav-link-item group relative flex w-full items-center justify-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold text-neutral-600 transition-all hover:bg-accent-50 hover:text-primary-700 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-primary-400"
      [class.px-4]="!isMinimized"
      [class.py-2.5]="!isMinimized"
      [class.px-2]="isMinimized"
      [class.py-2]="isMinimized"
      [class.text-sm]="!isMinimized"
      [attr.aria-label]="isMinimized ? 'Expand sidebar' : 'Collapse sidebar'"
    >
      @if (!isMinimized) {
        <span class="flex-1 text-left">{{ "COMPONENTS.NAVBAR_BODY.COLLAPSE" | translate }}</span>
        <svg
          class="h-4 w-4 flex-shrink-0 text-current"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
        </svg>
      } @else {
        <svg
          class="h-5 w-5 flex-shrink-0 text-current"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
        </svg>
      }
      <span class="nav-hover-indicator absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-primary-600 opacity-0 transition-opacity"></span>
    </button>
  </div>
</aside>
